import React, { useContext } from 'react';
import Sidebar from './components/Sidebar/Sidebar';
import LanguageBar from './components/LanguageBar/LanguageBar';
import InputFields from './components/InputFields/InputFields';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../customerFullInfoState/customerFullInfoContext';
import NoData from 'components/NoResultsFound/NoData';
import style from './LocalizationTab.module.scss';

const LocalizationTab: React.FC = () => {
	const { localizationData, selectedLocalizationLanguage, customerForFullInfo } =
		useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return (
		<div className={style.container} data-test="LocalizationTab">
			{localizationData && customerForFullInfo ? (
				<>
					{localizationData.groups.length ? (
						<>
							<div className={style.sidebar}>
								<Sidebar items={localizationData.groups} />
							</div>
							<div className={style.content}>
								<div className={style.languageBar}>
									<LanguageBar items={customerForFullInfo.languages} />
								</div>
								<div className={style.fields}>
									{customerForFullInfo.languages.map((el) => (
										<InputFields
											key={el.languageId}
											languageId={el.languageId}
											isVisible={selectedLocalizationLanguage?.id === el.languageId}
										/>
									))}
								</div>
							</div>
						</>
					) : (
						<NoData />
					)}
				</>
			) : null}
		</div>
	);
};

export default LocalizationTab;
